"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customCurrDateHeader = (arg) => {
    const headerCell = () => {
        return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'k-cell-inner' }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'k-link' }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'k-column-title' }, { children: arg.title })) })) })));
    };
    return headerCell;
};
exports.default = customCurrDateHeader;
